import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Separator from '../../../../core/layout/Separator';
import AnswersInputContainer from '../inputs/AnswersInputContainer';
import TranslationInputContainer from '../inputs/TranslationInputContainer';
import TextInput from '../../../../core/form/TextInput';
import Audios from '../inputs/Audios';
import Column from '../../../../core/layout/Column';
import Row from '../../../../core/layout/Row';
import Divider from '../../../../core/layout/Divider';
import LocalFileInput from '../../../../core/form/LocalFileInput';

const MultipleChoiceItemForm = (props) => (
  <div>
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Text"
          fieldType="textarea"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'text', '')}
          onChange={(value) => props.onChange('text', value)}
          errorText={get(props.errors, 'text', '')}
        />
      </Column>
    </Row>
    {!props.isTestItem && (
      <TranslationInputContainer
        onChange={props.onChange}
        submitting={props.submitting}
        values={props.values}
        errors={props.errors}
        disabled={props.disabled}
      />
    )}
    <Row>
      <Column size={4}>
        <Audios
          audioPath="audio"
          generatedAudioPath="generatedAudio"
          values={props.values}
          submitting={props.submitting}
          disabled={props.disabled}
          onChange={props.onChange}
          errors={props.errors}
        />
      </Column>
      {props.hasImage && (
        <Column size={4}>
          <LocalFileInput
            label="Upload an image to the item"
            accept="image"
            cropSize={{ width: 960, height: 640 }}
            disabled={props.disabled}
            value={get(props.values, 'image', '')}
            onChange={(key) => props.onChange('image', key)}
            errorText={get(props.errors, 'image', '')}
          />
        </Column>
      )}
    </Row>
    <Separator size="xs" />
    <Divider title="Answers" />
    <AnswersInputContainer
      label="Answer text"
      value={get(props.values, 'answers', [])}
      onChange={(answers) => props.onChange('answers', answers)}
      errorText={get(props.errors, 'answers', '')}
      type="SINGLE_CHOICE_TEXT"
      disabled={props.disabled}
      hasImage={false}
    />
  </div>
);

MultipleChoiceItemForm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  isTestItem: PropTypes.bool,
  hasImage: PropTypes.bool,
};

MultipleChoiceItemForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  disabled: false,
  isTestItem: false,
  hasImage: false,
};

export default MultipleChoiceItemForm;
